<template>
  <common-dialog ref="dialog" :title="title" width="1000px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column prop="FullName" label="姓名" />
      <el-table-column label="班级" min-width="100">
        <template slot-scope="{row}">
          <span>{{row.Grade + row.Class}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="AttendanceDate" label="日期" min-width="110">
        <template slot-scope="{row}">
          <span>{{$commonJs.toDateString(row.AttendanceDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="SectionName" label="节次" />
      <el-table-column prop="Remark" label="具体情况" min-width="140" />
      <el-table-column prop="HandleResult" label="处理结果" width="90" align="center">
        <template slot-scope="{row}">
          <el-tag type="success" size="small" v-if="row.HandleResult==1">正常缺勤</el-tag>
          <el-tag type="danger" size="small" v-else-if="row.HandleResult==2">异常缺勤</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="HandleStatus" label="状态" width="90" align="center">
        <template slot-scope="{row}">
          <el-tag type="warning" size="small" v-if="row.HandleStatus==0">待处理</el-tag>
          <el-tag type="success" size="small" v-else-if="row.HandleStatus==1">已处理</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/st/attendance").default,
      data: [],
      params: {},
      title: "导出 考勤异常信息",
    };
  },
  methods: {
    getData(params) {
      this.params = this.$commonJs.obj.removeNullKey(params);
      this.$refs.dialog.isLoading = true;
      this.api.list(this.params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>